<template>
  <div>
    <modal-crear-editar
      :configuracion="configuracion_modal"
      @realizado="restablecer_inputs"
    ></modal-crear-editar>
    <tablita
      :cols="columnas"
      @cargar="cargar($event)"
      @cargar_url="cargar_url($event)"
      @nuevo="crear"
      @editar="editar($event)"
      @editar_tarifas="editar_tarifas($event)"
      :configuracion="configuracion_tabla"
      @refresh="refrescar($event)"
    ></tablita>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ModalCrearEditar from "../../../components/Modal/ModalEditarCrear";
import Tabla from "../../../components/Tabla/Tabla";
//import lenguaje from '../../config/es_datatable.json'
export default {
  data: () => ({
    filter: "",
    columnas: [
      //{key:'id',label:'Id',busqueda:'',tipo:'number',searchable:false,path:'id'},
      {
        key: "transportes_id",
        label: "Camión",
        busqueda: "",
        tipo: "select-loadable",
        ruta: "/transportes",
        parametro: "patente",
        append_parametro: "",
        searchable: true,
        path: "patente",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "patente",
      },
      {
        key: "vigente_desde",
        label: "Vigente Desde",
        busqueda: "",
        tipo: "date",
        searchable: true,
        path: "vigente_desde",
      },
      {
        key: "vigente_hasta",
        label: "Vigente Hasta",
        busqueda: "",
        tipo: "date",
        searchable: true,
        path: "vigente_hasta",
      },
      {
        key: "valor",
        label: "Costo Arriendo Mensual",
        busqueda: "",
        tipo: "number",
        searchable: true,
        path: "valor",
      },
      {
        key: "valor_diario",
        label: "Valor Diario",
        busqueda: "",
        tipo: "number",
        searchable: true,
        path: "valor_diario",
      },
    ],
    botones: [
      {
        label: "Editar",
        clase: "btn-warning",
        evento: "editar",
        icono: "fa fa-pen",
      },
    ],
    lista: [],
    links: [],
    inputs: [
      {
        cols: 4,
        tipo: "select-loadable",
        key: "transportes_id",
        valor: "",
        label: "Camión (*)",
        busqueda: "",
        ruta: "/transportes",
        parametro: "patente",
        disabled: false,
        opciones: [],
        valor_opcion: "id",
        label_opcion: "patente",
      },
      //{cols:4,tipo:'v-select',key:'transportes_id',valor:'',label:'Camión (*)',opciones:[],label_opcion:'patente'},
      {
        cols: 4,
        tipo: "datetime",
        key: "vigente_desde",
        valor: "",
        label: "Vigente Desde (*)",
        disabled: true,
      },
      {
        cols: 4,
        tipo: "datetime",
        key: "vigente_hasta",
        valor: "",
        label: "Vigente Hasta",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "numero",
        key: "valor",
        valor: "",
        label: "Costo Arriendo Mensual (*)",
        disabled: false,
      },
    ],
    configuracion_modal: {
      titulo: "Registrar Tarifa de Arriendo",
      ancho: "xl",
      ruta: "/tarifas_arriendos_camiones",
      tipo_ruta: "post",
      titulo_boton: "Crear",
      clase_boton: "btn-success",
    },
    configuracion_tabla: {
      titulo: "Listado de Tarifas de Arriendo",
      titulo_boton: "Crear Tarifa Arriendo",
      clase_boton: "btn-primary",
      btn_nuevo: true,
    },
    transportes_id: null,
    transportes: [],
    pagina_actual: "",
  }),
  mounted() {
    //this.transportes_id = this.$route.params.transportes_id;
    //this.inputs[3].valor = this.transportes_id;
    //this.columnas[0].busqueda = this.transportes_id;
    this.inicializar_tabla({
      columnas: [],
      lista: [],
      links: [],
      botones: [],
      botones_restringidos: [],
    });
    let storage = localStorage.getItem(this.path);
    if (storage) {
      storage = JSON.parse(storage);
      this.columnas.forEach((col) => {
        col.busqueda = storage.columnas.find((c) => c.key == col.key).val;
      });
    }
    this.cargar_transporte();
  },
  methods: {
    refrescar() {
      localStorage.removeItem(this.path);
      this.columnas.forEach((c) => {
        if (
          [
            "string",
            "number",
            "select",
            "select-loadable",
            "select-loadable-dependiente",
            "datetime",
            "html",
            "html_select",
          ].includes(c.tipo)
        ) {
          c.busqueda = "";
        }

        if (["multiselect"].includes(c.tipo)) {
          c.busqueda = [];
        }
      });
      this.$emit("cargar");
    },
    async cargar_transporte() {
      await this.axios
        .get(`${this.api}/transportes`, this.cabeceras_json)
        .then((res) => {
          this.transportes = res.data.data.data;
          //this.inputs[0].opciones = this.transportes;
          //this.cargar('');
        })
        .catch((e) => {
          //alert(e);
        });
      //this.cargar("");
      this.$emit("cargar");
    },
    async cargar($event) {
      this.lista = [];
      this.pagina_actual = `${this.api}/tarifas_arriendos_camiones${$event}`;
      await this.axios
        .get(
          `${this.api}/tarifas_arriendos_camiones${$event}`,
          this.cabeceras_json
        )
        .then((res) => {
          this.lista = res.data.data.data;
          this.links = res.data.data.links;
          /* let config = {
                  columnas:this.columnas,
                  lista:this.lista,
                  links:this.links
                } */
          this.inicializar_tabla({
            columnas: this.columnas,
            lista: this.lista,
            links: this.links,
            botones: this.botones,
          });
          this.$emit("generar", this.columnas, this.lista);
          ////console.log('listado',res.data.data.data);
          //$('#empresas').DataTable().draw();
        })
        .catch((e) => {
          //alert(e);
        });
    },
    async cargar_url(url) {
      if (url) {
        this.pagina_actual = url;
        await this.axios
          .get(url, this.cabeceras_json)
          .then((res) => {
            this.lista = res.data.data.data;
            this.links = res.data.data.links;
            ////console.log('listado',res.data.data.data);
            this.setear_lista({ lista: this.lista, links: this.links });
            //$('#empresas').DataTable().draw();
          })
          .catch((e) => {
            //alert(e);
          });
      }
    },
    crear() {
      this.setear_inputs(this.inputs);
      this.restablecer_inputs();
      this.configuracion_modal.titulo = `NUEVA TARIFA`;
      this.configuracion_modal.ruta = `/tarifas_arriendos_camiones`;
      this.configuracion_modal.tipo_ruta = "post";
      this.configuracion_modal.titulo_boton = "Crear";
      this.configuracion_modal.clase_boton = "btn-success";

      this.$emit("abrir", { inputs: this.inputs });
    },
    async editar(evento) {
      //console.log('evento',evento);
      let item = evento.item;
      await this.inputs.forEach((i) => {
        //recorrido del objeto a editar
        Object.keys(item).forEach((key) => {
          let valor = item[key];
          if (i.key == key) {
            if (i.tipo == "datetime" || i.tipo == "date") {
              if (valor) {
                valor = this.$moment(valor).format("YYYY-MM-DD");
              }
              i.valor = valor;
            } else {
              i.valor = valor;
            }
            console.log(i.tipo, valor);
          }
        });
      });
      console.log("inputs", this.inputs);
      //this.inputs[0].disabled = true;
      this.setear_inputs(this.inputs);
      this.configuracion_modal.ruta = `/tarifas_arriendos_camiones/${evento.item.id}`;
      this.configuracion_modal.tipo_ruta = "put";
      this.configuracion_modal.titulo_boton = "Actualizar";
      this.configuracion_modal.clase_boton = "btn-warning";

      this.$emit("abrir");
    },
    editar_tarifas(evento) {
      //console.log(evento)
    },
    restablecer_inputs() {
      this.cargar_url(this.pagina_actual);
      this.inputs.forEach((i) => {
        if (i.tipo != "hidden") {
          i.valor = "";
        }
      });
      this.setear_inputs(this.inputs);
    },
    ...mapActions(["inicializar_tabla", "setear_lista", "setear_inputs"]),
  },
  components: {
    "modal-crear-editar": ModalCrearEditar,
    tablita: Tabla,
  },
  computed: {
    ...mapState(["api", "cabeceras_json"]),
    query() {
      let string = "?";
      let and = "";
      let total = this.columnas.length - 1;
      this.columnas.forEach((c, index) => {
        if (index > 0 && string.length > 0) {
          and = "&";
        } else if (index == total) {
          and = "";
        }

        if (c.busqueda != "") {
          string += `${and}${c.key}=${c.busqueda}`;
        }
      });
      return string;
    },
    path() {
      return this.$router.currentRoute.path;
    },
  },
};
</script>
<style>
.form-control {
  height: calc(1em + 1.25rem + 5px);
}
</style>